import { Box, Alert } from '@deere/fuel-react';

export const AlertBox = (props) => {
    return (
        <Box
            marginX="auto"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'left',
                alignItems: 'left',
            }}
        >
            <Alert
                variant={props.variant}
                onClose={props.handleClose ? props.handleClose : undefined}
            >
                {props.msg}
            </Alert>
        </Box>
    );
};
